/**
 * Normalizes Axios-style errors into a readable message for users.
 */

const APPLICATION_ERROR_HINTS = {
  WalletNotFound: 'Your billing wallet is not provisioned yet, or could not be found. Contact support if you need access.',
};

function extractBackendCode(error) {
  const data = error?.response?.data;
  const nested = data?.error;
  if (nested && typeof nested === 'object' && nested.error !== undefined && nested.error !== null) {
    return String(nested.error);
  }
  if (typeof data?.error === 'string') {
    return data.error;
  }
  return null;
}

export function getApiErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  if (!error) {
    return fallback;
  }

  const data = error.response?.data;
  const code = extractBackendCode(error);
  const hint = code && APPLICATION_ERROR_HINTS[code] ? APPLICATION_ERROR_HINTS[code] : null;

  const serverMessage =
    typeof data?.message === 'string' && data.message.trim() ? data.message.trim() : null;

  if (serverMessage && hint) {
    return `${serverMessage} ${hint}`;
  }
  if (serverMessage) {
    return serverMessage;
  }
  if (hint) {
    return hint;
  }

  if (error.message && typeof error.message === 'string' && error.message !== 'Request failed with status code 403') {
    return error.message;
  }

  const status = error.response?.status;
  if (status === 402) {
    return serverMessage || 'Payment failed. Please check your card and try again.';
  }
  if (status === 403) {
    return 'You do not have permission to perform this action.';
  }
  if (status === 401) {
    return 'Your session has expired. Please sign in again.';
  }

  if (!error.response) {
    return 'Network error. Check your connection and try again.';
  }

  return fallback;
}

/** Deduplicate identical messages from parallel billing fetches (e.g. WalletNotFound on all three). */
export function uniqueErrorMessages(messages) {
  return messages.reduce((acc, m) => {
    if (!m || acc.includes(m)) {
      return acc;
    }
    return [...acc, m];
  }, []);
}
